import dayjs from 'dayjs';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useUserAccessStore } from './userAccessStore.ts';

interface IAccessDeniedModal {
    modalType: string;
    text: string;
}

export interface IGlobalNotification {
    formattedDate: string;
    text: string;
}

export const BrowserRefreshWarningText = 'Warning: Refresh Needed<br>This Enact tab has missed live updates for an extended period of time (5 minutes), please refresh to resume live updates.</br>';

export const useAlertStore = defineStore('alertStore', () => {
    const accessDeniedModal = ref<IAccessDeniedModal>({ modalType: '', text: '' });
    const showAccessDeniedModal = ref<boolean>(false);
    const globalNotificationsToShow = ref<Array<IGlobalNotification>>([]);

    function setAccessDeniedModal (modalType: string, text: string): void {
        accessDeniedModal.value = { modalType, text };
    }

    function setShowAccessDeniedModal (show?: boolean): void {
        showAccessDeniedModal.value = show ?? false;
    }

    function pushGlobalPowerMarketsNotification (data: string): void {
        const userAccessStore = useUserAccessStore();
        if (!userAccessStore.userAccess.enact.shortTermMarkets) return;
        if (data.includes('Warning: Refresh Needed')) {
            globalNotificationsToShow.value = globalNotificationsToShow.value.filter(notification => !notification.text.includes('Warning: Refresh Needed'));
        }

        globalNotificationsToShow.value.push({
            formattedDate: dayjs().format('DD/MM/YYYY HH:mm:ss'),
            text: data,
        });
    }

    function removeAllGlobalNotifications (): void {
        globalNotificationsToShow.value = [];
    }

    return {
        accessDeniedModal,
        showAccessDeniedModal,
        globalNotificationsToShow,
        setShowAccessDeniedModal,
        setAccessDeniedModal,
        pushGlobalPowerMarketsNotification,
        removeAllGlobalNotifications,
    };
});
